import styled from '@emotion/styled';

import DimiCard from './DimiCard';

const DimiMenu = styled(DimiCard)`
  padding: 1.5rem 0.75rem 1.5rem 0 !important;
  margin-bottom: 2rem;
`;

export default DimiMenu;
